import { BLENDING_MODE_CHANGE, LAYER_TOGGLE_HIDE } from './actionTypes';

export const toggleHide = (id: string, type: string) => ({
    type: LAYER_TOGGLE_HIDE,
    payload: {
        id,
        type,
    },
});

export const changeMode = (id: string, type: string, mode: string) => ({
    type: BLENDING_MODE_CHANGE,
    payload: {
        mode,
        id,
        type,
    },
});
